/**
 * index.js
 *
 * @Author: jruif
 * @Date: 2017/7/15 下午12:21
 */
import Tooltip from './Tooltip';

export default Tooltip;



// WEBPACK FOOTER //
// ./src/tooltip/index.js